import Phaser from "phaser";
import { GameScene } from "./GameScene";

/**
 * Phaser game entry point.
 *
 * Canvas size: 720 x 960 portrait. Fit-mode scales the canvas to the window
 * while preserving the internal resolution — works for both desktop and mobile.
 */
const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: "game-container",
  backgroundColor: "#1a1a2e",
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: 720,
    height: 960,
  },
  scene: [GameScene],
};

new Phaser.Game(config);
